<template>
  <div class="comment-posted-row">
    <div
      v-member-hover-preview="getHoverMember"
      class="posted-by-user"
    >
      {{ displayName }}
    </div>
    <GuestMemberLabel
      v-if="!deactivated && memberRole === MemberRole.Guest"
      :member-role="memberRole"
      :class-style="'ml-1 lowercase text-sm text-text-default font-normal'"
    />
    <span
      v-if="deactivated"
      class="ml-1 text-sm text-text-default font-normal"
    >
      {{ deactivated }}
    </span>
    <div class="posted-time mr-2">
      <span>{{ isEdited }}</span>
      <span
        v-tooltip="{
          content: timeCreatedTooltipFormat,
          placement: 'top',
        }"
        >{{ publishedDifference }}</span
      >
    </div>
  </div>
</template>
<script setup>
import { MemberRole } from '@superthread-com/api';
</script>
<script>
import { timeDifference, convertTimestampToDDMlabelTime } from '@/utilities/timeDifference';
import GuestMemberLabel from '@/components/widgets/GuestMemberLabel';

export default {
  name: 'CommentPostedByRow',
  components: {
    GuestMemberLabel,
  },
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      publishedDifference: this.getTimeDifference(+this.comment.time_created, 1, true),
      recalcTimeout: null,
    };
  },
  computed: {
    deactivated() {
      const inactiveMember = this.$store.getters.getInactiveTeamMembers[this.owner.id] || {};
      const isDeactivated = Object.keys(inactiveMember).length > 0;
      return isDeactivated ? ` (${this.translate('deactivated')})` : '';
    },
    owner() {
      return this.$store.getters.getMemberById(this.comment.user_id);
    },
    displayName() {
      if (this.isGuestRole && !Object.keys(this.owner).length) {
        return this.translate('hiddenMember');
      }
      return this.owner?.display_name || '';
    },
    getHoverMember() {
      if (this.isGuestRole && !Object.keys(this.owner).length) {
        return { id: this.comment.user_id };
      }
      return this.owner;
    },
    isEdited() {
      return this.comment.time_created !== this.comment.time_updated
        ? `(${this.translate('edited')}) `
        : '';
    },

    timeCreatedTooltipFormat() {
      return convertTimestampToDDMlabelTime(this.comment.time_created);
    },
    memberRole() {
      return this.owner.role || '';
    },
  },
  mounted() {
    this.recalcTimeout = setTimeout(() => {
      this.publishedDifference = this.getTimeDifference(+this.comment.time_created, 1, true);
    }, 10000);
  },
  unmounted() {
    clearTimeout(this.recalcTimeout);
  },
  methods: {
    getTimeDifference(time, depth, shortFormat) {
      const realTime = +time * 1000;
      return timeDifference(realTime, depth, false, shortFormat);
    },
  },
};
</script>

<style lang="scss">
.comment-posted-row {
  @apply w-full
    flex
    flex-row
    items-center
    truncate
    ml-3;

  .posted-by-user {
    @apply font-medium
      text-sm
      h-full
      text-text-default
      truncate;
  }

  .posted-time {
    @apply ml-2
      font-normal
      text-xs
      leading-[1.125rem]
      text-text-default;
  }
}
</style>
